import "@babel/polyfill";
import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles';
import {
    Drawer,
    AppBar,
    Toolbar,
    CssBaseline,
    Typography,
    IconButton,
    Hidden,
    Menu,
    MenuItem,
} from '@material-ui/core';
import Dialog from 'mdoc/utils/myDialog';
import {
    Menu as MenuIcon,
    AccountCircle,
} from '@material-ui/icons';
import SiderCustom from 'mdoc/admin/components/SiderCustom';
import Footer from 'mdoc/admin/components/Footer';
import { receiveData } from 'mdoc/action/admin';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Routes from 'mdoc/admin/routes/index';
import { getUserInfo, logout, dictionary, clientsInfo } from 'mdoc/admin/axios';
import Toast from 'mdoc/utils/toast';
import routesConfig from 'mdoc/admin/routes/config';
import eventProxy from 'mdoc/utils/eventProxy';

const drawerWidth = 240;

const styles = theme => ({
    root: {
        display: 'flex'
    },
    grow: {
        flexGrow: 1,
    },
    drawer: {
        [theme.breakpoints.up('sm')]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    appBar: {
        paddingLeft: drawerWidth,
        [theme.breakpoints.up('sm')]: {
            width: '100%',
        },
    },
    menuButton: {
        marginRight: 20,
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        width: drawerWidth,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing.unit * 4,
    },
    contentBottom: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%'
    }
});
let menuTitle = '';
class Admin extends Component {
    state = {
        mobileOpen: false,
        anchorEl: null,
        dictWord: {
            'logoff': '',
            'reset_password': '',
            'available_capacity': '',
            'content_count': '',
            'service_start_date': '',
            'service_end_date': '',
            'user_count': '',
            'management_menu': '',
            'client': '',
            'enterprise_managers': '',
            'associate_enterprise_managers': '',
            'managers_id': '',
            'department': '',
            'category': '',
            'rocket': '',
            'content': '',
            'content_management': '',
            'content_registration': '',
            'notice': '',
            'notification_release': '',
            'push_notice': '',
            'management': '',
            'registered_clients_count': '',
            'runing_clients_count': '',
            'created_user_count': '',
            'book_count': '',
            'group': '',
            'user': '',
            'user_multiple_registration': '',
            'user_registration': '',
            'associate_enterprise_managers_registration': '',
            'push_notice_registration': '',
            'enterprise_managers_registration': '',
            'notification_release_registration': '',
            'content_multiple_registration': '',
            'client_login': '',
            'push_notice_management': '',
            'notification_release_management': '',
            'content_list': '',
            'category_management': '',
            'department_management': '',
            'user_view': '',
            'associate_enterprise_managers_list': '',
            'enterprise_managers_list': '',
            'client_list': '',
            'detail': '',
            'client_login_confirmation': '',
            'user_log': '',
            'application_list': '',
            'content_add': '',
            'application_import': '',
            'department_user_edit': '',
            'reader_edit': '',
            'web_design': '',
            'app_design': '',
            'active_directory': '',
            'active_directory_add': '',
            'active_directory_setting': '',
            'msg_confirm_logoff':'',
            'yes':'',
            'cancel':''
        },
        loginName: '',
        menuTitle: '',
        clientsInfo: {
            registeredClientsCount: 0,
            runingClientsCount: 0,
            createdUserCount: 0,
            bookCount: 0,
            diskSize: 0,
            startTimeStr: 0,
            endTimeStr: 0,
            userCreateNum: 0
        },
        dialogOpen: false,
    };

    componentWillMount() {
        const { receiveData } = this.props;
        let user = getUserInfo();
        user && receiveData(user, 'auth');
        let dict = {};
        dictionary(this.state.dictWord).then(res => {
            for (let key in res) {
                let val = res[key];
                dict[val.dictKey] = val.dictValue;
            }
            this.setState({
                loginName: user.userName,
                dictWord: dict,
            })
        });
        clientsInfo().then(res => {
            this.setState({
                clientsInfo: res,
            })
        }).catch(function (err) {
            Toast.error(err);
        })
    }

    componentDidMount() {
        eventProxy.on('msg', res => {
            this.setState({ clientsInfo: res })
        })
        eventProxy.on('numChange', res => {
            this.setState({ clientsInfo: res })
        })
        eventProxy.on('loginNumChange', res => {
            this.setState({ clientsInfo: res })
        })
        eventProxy.on('uploadFiles', res => {
            this.setState({ clientsInfo: res })
        })
        eventProxy.on('uploadMultiple', res => {
            this.setState({ clientsInfo: res })
        })
    }
    componentDidUpdate() {
        document.getElementById('root').children[0].style.marginBottom = '53px';
    }

    handleDrawerToggle = () => {
        this.setState(state => ({ mobileOpen: !state.mobileOpen }));
    };
    handleLogout = () => {
        this.setState({
            dialogOpen: true
        })
       
    }
    resetPassword = () => {
        this.props.history.push('/passwordReset');
    }

    dialogHandleClose = () => {
        this.setState({
            dialogOpen: false,
            anchorEl: null
        });
    }
    dialogHandleOk = () => {
        logout();
        this.props.history.replace('/login');
    }

    handleMenu = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    findMenuTitle = () => {
        menuTitle = '';
        let pathname = this.props.location.pathname;
        for (let key in routesConfig) {
            for (let rKey in routesConfig[key]) {
                let r = routesConfig[key][rKey];
                if (r['subs'] !== undefined) {
                    for (let num in r['subs']) {
                        let v = r['subs'][num];
                        if (v['key'] === pathname) {
                            menuTitle = this.state.dictWord[v['menuDictKey']];
                            break;
                        }
                    }
                } else {
                    let index = r['key'].indexOf(':');
                    if (index >= 0) {
                        let configPath = r['key'].substr(index);
                        let Path = pathname.substr(index);
                        let newPath = r['key'];
                        if (pathname === r['key'].replace(configPath, Path)) {
                            newPath = r['key'].replace(configPath, Path);
                        }
                        if (newPath === pathname) {
                            menuTitle = this.state.dictWord[r['menuDictKey']].replace('%s', this.state.dictWord[r['titleDictKey']]);
                        }
                    } else {
                        if (r['key'] === pathname) {
                            menuTitle = this.state.dictWord[r['menuDictKey']].replace('%s', this.state.dictWord[r['titleDictKey']]);
                        }
                    }
                }
            }
        }
    }

    render() {
        const { auth, classes, theme } = this.props;
        const { anchorEl, dictWord, clientsInfo } = this.state;
        const open = Boolean(anchorEl);
        const drawer = (
            <SiderCustom auth={auth} dictWord={dictWord} clientsInfo={clientsInfo} />
        );
        this.findMenuTitle();
        return [
            <div key={0} className={classes.root}>
                <CssBaseline />
                <AppBar position="fixed" className={classes.appBar}>
                    <Toolbar>
                        <IconButton
                            color="inherit"
                            aria-label="Open drawer"
                            onClick={this.handleDrawerToggle}
                            className={classes.menuButton}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="h6" color="inherit" className={classes.grow}>
                            <span>{menuTitle}</span>
                        </Typography>
                        {auth.data && (
                            <div>
                                <div
                                    style={{ display: 'flex', cursor: 'pointer' }}
                                    onClick={this.handleMenu}
                                >
                                    <AccountCircle />
                                    <span style={{ lineHeight: '24px',marginLeft:'5px' }}>{this.state.loginName}</span>
                                </div>
                                <Menu
                                    id="menu-appbar"
                                    anchorEl={anchorEl}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    disableAutoFocusItem
                                    open={open}
                                    onClose={this.handleClose}
                                >
                                    <MenuItem onClick={this.handleLogout}>{dictWord.logoff}</MenuItem>
                                    <MenuItem onClick={this.resetPassword}>{dictWord.reset_password}</MenuItem>
                                </Menu>
                            </div>
                        )}
                    </Toolbar>
                </AppBar>
                <div className={classes.contentBottom}>
                    {auth.data ? <nav className={classes.drawer}>
                        {/* The implementation can be swap with js to avoid SEO duplication of links. */}
                        <Hidden smUp implementation="css">
                            <Drawer
                                container={this.props.container}
                                variant="temporary"
                                anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                                open={this.state.mobileOpen}
                                onClose={this.handleDrawerToggle}
                                classes={{
                                    paper: classes.drawerPaper,
                                }}
                                ModalProps={{
                                    keepMounted: true, // Better open performance on mobile.
                                }}
                            >
                                {drawer}
                            </Drawer>
                        </Hidden>
                        <Hidden xsDown implementation="css">
                            <Drawer
                                classes={{
                                    paper: classes.drawerPaper,
                                }}
                                variant="permanent"
                                open
                            >
                                {drawer}
                            </Drawer>
                        </Hidden>
                    </nav> : null}
                    <div className={classes.content}>
                        <Routes auth={auth} />
                    </div>
                </div>
                <Dialog
                    open={this.state.dialogOpen}
                    option={{
                        ok: {
                            text: this.state.dictWord['yes'],
                        },
                        close: {
                            text: this.state.dictWord['cancel'],
                        },
                    }}
                    content={
                        <p>
                            {this.state.dictWord['msg_confirm_logoff']}
                        </p>
                    }
                    handleOk={this.dialogHandleOk.bind(this)}
                    handleClose={this.dialogHandleClose}
                />
            </div>,

            <Footer key={1} />
        ];
    }
}

Admin.propTypes = {
    classes: PropTypes.object.isRequired,
    container: PropTypes.object,
    theme: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
    const { auth = { data: {} }, responsive = { data: {} } } = state.reducer.httpData
    return { auth, responsive }
}

const mapDispatchToProps = dispatch => ({
    receiveData: bindActionCreators(receiveData, dispatch)
})

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(Admin))